export const logUserActivity = async (exportType, filterModel, nbrOfRows, api) => {
  const activeFilters = filterModel?.items?.filter((item) => item.value !== undefined && item.value !== "") || [];
  const filterText = activeFilters.map((f) => `${f.field} ${f.operator} ${f.value}`).join(", ");

  let response = null;
  let reqObj = {
    activityType: 1,
    metaData: JSON.stringify({
      exportType: exportType,
      nbrOfRows: nbrOfRows,
      activeFilter: filterText,
      url: window.location.href,
    }),
  };

  response = await api.fetch(`${import.meta.env.VITE_MAIN_URL}loggers/useractivity`, reqObj, "POST");
};

export default {
  logUserActivity: logUserActivity,
};
